import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store'
// import vueresource from 'vue-resource'
import VueSimpleAlert from 'vue-simple-alert'
import Vuelidate from 'vuelidate'
import VueHtmlToPaper from 'vue-html-to-paper'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import { captureAttribution } from './utils/attribution'

import 'document-register-element/build/document-register-element'
import vueCustomElement from 'vue-custom-element'
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ]
}
const toastOptions = {
  // You can set your default options here
  timeout: 10000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false
}

Vue.config.productionTip = false

// Read ad click / UTM parameters before the router rewrites the URL
captureAttribution()

Vue.use(vueCustomElement)
// Vue.use(vueresource)
Vue.use(VueAxios, axios)
Vue.use(Toast, toastOptions)
Vue.use(VueSimpleAlert)
Vue.use(Vuelidate)
Vue.use(VueHtmlToPaper, options)

App.router = router
App.store = store
// App.vueresource = vueresource
// App.router.replace('/')
Vue.customElement('booking-widget', App)



// WEBPACK FOOTER //
// ./src/main.js